import { GTM_EVENTS } from 'src/shared/constants';
import { gtmUtils } from 'src/shared/toolbox';

import i18n from './i18n';

/**
 * GTM language tracking bootstrap for i18n.
 */
export class i18nGtmTracking {
	/**
	 * Initialize GTM language tracking.
	 */
	static init(): void {
		// Initial language detection push
		try {
			if (i18n.language) {
				gtmUtils.pushDataLayerGTM({
					event: GTM_EVENTS.LANGUAGE_DETECTED,
					site_language: i18n.language
				});
			}
		} catch (error) {
			console.error('GTM language detection error:', error);
		}

		// Subscribe to future language changes
		i18n.on('languageChanged', (language: string) => {
			try {
				gtmUtils.pushDataLayerGTM({
					event: GTM_EVENTS.LANGUAGE_CHANGED,
					site_language: language
				});
			} catch (error) {
				console.error('GTM language change error:', error);
			}
		});
	}
}
